export default function (client) {
    return {
        search: async function (query) {
            return await client.get('/geo/search', {
                params: query
            });
        }
    }
}